export const FILE_UPLOAD_CONFIG = {
  UPLOAD_FILE: {
    endPoint: 'upload-file', //needed to be changed when api is available
    method: 'POST',
  },
  UPLOAD_BULK_MODIFIER_FILE: {
    endPoint: 'bulk-point-modifier/stores-upload-csv', //For bulk point modifiers
    method: 'POST',
    contentType: 'multipart/form-data',
    headers: {Accept: '*/*'},
    multipart: 'multipart',
  },
  UPLOAD_SALES_TARGET_CONTENT: {
    endPoint: 'sale-targets/uploadMedia', //For sales Target
    method: 'POST',
    contentType: 'multipart/form-data',
    headers: {Accept: '*/*'},
    multipart: 'multipart',
  },
  UPLOAD_SALES_TARGET_MEDIA: {
    endPoint: 'sale-targets/media/upload', // New Azure Blob/CDN endpoint
    method: 'POST',
    contentType: 'multipart/form-data',
    headers: {Accept: '*/*'},
    multipart: 'multipart',
  },
  REWARDS_TIER_STORE_UPLOAD: {
    endPoint: 'tiers/upload-stores',
    method: 'POST',
    contentType: 'multipart/form-data',
    headers: {Accept: '*/*'},
    multipart: 'multipart',
  },
}
